"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signedMoneyAmountPrimitiveSchema = exports.moneyAmountPrimitiveSchema = exports.CENTS_PER_DOLLAR = void 0;
const zod_1 = require("zod");
exports.CENTS_PER_DOLLAR = 100;
exports.moneyAmountPrimitiveSchema = zod_1.z.number().int().min(0);
exports.signedMoneyAmountPrimitiveSchema = zod_1.z.number().int();
